/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FirmwareByIdResponse { 
    id: string;
    name: string;
    version: string;
    comment?: string | null;
    originFileName: string;
    equipmentModelIds: Array<string>;
}

